import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KnownIpAddressRoutingModule } from './known-ip-address-routing.module';
import { SharedModule } from '../../../../shared/shared.module';
import { KnownIpAddressEditComponent } from './known-ip-address-edit/known-ip-address-edit.component';
import { KnownIpAddressDetailsComponent } from './known-ip-address-details/known-ip-address-details.component';

@NgModule({
  declarations: [
    KnownIpAddressEditComponent,
    KnownIpAddressDetailsComponent
  ],
  imports: [CommonModule, SharedModule, KnownIpAddressRoutingModule],
})
export class KnownIpAddressModule {}
